import {concat, filter, groupBy, map} from 'lodash';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';

import FormikDropdown from 'src/components/formik-dropdown';
import Label from 'shared/components/label';
import CoursesService from 'src/services/CoursesService';

interface Props {
  apCourseNames: string[];
}

interface SubjectItem {
  text: string;
  value: string;
  group?: string;
}

const ApSubjectDropdown = (props: Props) => {
  const [apSubjects, setApSubjects] = useState<string[]>([]);

  useEffect(() => {
    CoursesService.getCourses().then((data) => {
      setApSubjects(data.apCourses.map((course) => course.name).sort());
    });
  }, []);

  const subjectsList = (): SubjectItem[] => {
    const {apCourseNames} = props;

    const subjects = groupBy(apSubjects, (subject) =>
      apCourseNames.indexOf(subject) === -1 ? 'Other Courses' : 'Your Courses'
    );

    if (!subjects['Your Courses']) {
      return map(subjects['Other Courses'], (subject) => ({
        text: subject,
        value: subject,
      }));
    } else if (!subjects['Other Courses']) {
      return map(subjects['Your Courses'], (subject) => ({
        text: subject,
        value: subject,
      }));
    } else {
      return concat(
        map(subjects['Your Courses'], (subject) => ({
          text: subject,
          value: subject,
          group: 'Your Courses',
        })),
        map(subjects['Other Courses'], (subject) => ({
          text: subject,
          value: subject,
          group: 'Other Courses',
        }))
      );
    }
  };

  return (
    <Label required>
      Select AP Test
      <FormikDropdown name="subject" options={subjectsList()} required />
    </Label>
  );
};

const mapStateToProps = (state: $TSFixMe): {apCourseNames: string[]} => {
  const apCourses = filter(Object.values(state.bulkEntryCourses), {courseType: 'AP'});
  const apCourseNames = map(apCourses, 'name');
  return {apCourseNames};
};

export default connect(mapStateToProps)(ApSubjectDropdown);
